import FW from '../fw/fw';
import Logger from '../fw/logger';


export default class ExtraModule {

  #rmp;
  #theatherModeEnabled = false;
  #onLoopInteractionFn = null;
  #onTheaterInteractionFn = null;
  #initialTheaterWidth = -1;
  #initialTheaterHeight = -1;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  #onLoopInteraction(event) {
    FW.eventStopPrevent(event);
    Logger.print('loop', 'requesting loop mode');
    if (this.#rmp.loopConfiguration) {
      this.#rmp.dom.loop.firstChild.firstChild.classList.remove('rmp-color-accent');
      this.#rmp.loopConfiguration = false;
    } else {
      this.#rmp.dom.loop.firstChild.firstChild.classList.add('rmp-color-accent');
      this.#rmp.loopConfiguration = true;
    }
  }

  #appendOverlayInfo() {
    const infoText = FW.createElement('div', 'rmp-info-text');
    infoText.innerHTML = this.#rmp.infoModule;
    this.#rmp.dom.infoOverlayLevelsArea.appendChild(infoText);
  }

  #onTheaterInteraction(event) {
    FW.eventStopPrevent(event);
    Logger.print('theater', 'requesting theater mode');
    if (this.#initialTheaterWidth > 0 && this.#initialTheaterHeight > 0) {
      if (this.#theatherModeEnabled) {
        this.#theatherModeEnabled = false;
        this.#rmp.dom.container.classList.remove('rmp-theater-on');
        const newPlayerSize = {
          width: this.#initialTheaterWidth,
          height: this.#initialTheaterHeight
        };
        this.#rmp.setPlayerSize(newPlayerSize);
      } else {
        this.#theatherModeEnabled = true;
        const parentWidth = FW.getPrecisionWidthNoPaddingNoBorder(this.#rmp.dom.containerParent);
        this.#rmp.dom.container.classList.add('rmp-theater-on');
        const parentHeight = parentWidth * this.#initialTheaterHeight / this.#initialTheaterWidth;
        Logger.print('theater', 'parentWidth is ' + parentWidth + ' and parentHeight is ' + parentHeight);
        const newPlayerSize = {
          width: parentWidth,
          height: parentHeight
        };
        this.#rmp.setPlayerSize(newPlayerSize);
      }
    }
  }

  initLoop() {
    this.#rmp.rmpModuleManagement.appendToModuleBar('loop');
    this.#onLoopInteractionFn = this.#onLoopInteraction.bind(this);
    FW.addEvents(['touchend', 'click'], this.#rmp.dom.loop, this.#onLoopInteractionFn);
  }

  initInfo() {
    this.#rmp.rmpModuleManagement.appendToModuleBar('info');
    this.#rmp.rmpModuleManagement.appendOverlay('info');
    this.#appendOverlayInfo();
  }

  initTheater() {
    this.#rmp.rmpModuleManagement.appendToModuleBar('theater');
    this.#initialTheaterWidth = this.#rmp.rmpSizeManagement.initialWidth;
    this.#initialTheaterHeight = this.#rmp.rmpSizeManagement.initialHeight;
    this.#onTheaterInteractionFn = this.#onTheaterInteraction.bind(this);
    FW.addEvents(['touchend', 'click'], this.#rmp.dom.theater, this.#onTheaterInteractionFn);
  }

}
